export const OUTSCHOOL_ENV = process.env.OUTSCHOOL_ENV ?? "development";

export const APP_HOSTNAME = process.env.APP_HOSTNAME;
export const isProduction = OUTSCHOOL_ENV === "production";
export const isTest = OUTSCHOOL_ENV === "test";

export const TRANSLATIONS_ENDPOINT =
  process.env.TRANSLATIONS_ENDPOINT ?? "https://outschool.com/_translate";

// Allows us to avoid the CF redirect for google login in staging.
export const CF_ACCESS_CLIENT_ID = process.env.CF_ACCESS_CLIENT_ID;
export const CF_ACCESS_CLIENT_SECRET = process.env.CF_ACCESS_CLIENT_SECRET;
